const AnalysisTypes = {
  READY: 'Готов',
  AT_WORK: 'В работе',
  SCHEDULED: 'Назначен',
  PARTIALLY_COMPLETED: 'Частично выполнен'
}
const PaymentStatusTypes = {
  PAID: 'Оплачен',
  NOT_PAID: 'Не оплачен'
}

const alphabet = [
  'А',
  'Б',
  'В',
  'Г',
  'Д',
  'Е',
  'Ж',
  'З',
  'И',
  'К',
  'Л',
  'М',
  'Н',
  'О',
  'П',
  'Р',
  'С',
  'Т',
  'У',
  'Ф',
  'Х',
  'Ц',
  'Ч',
  'Ш',
  'Щ',
  'Э',
  'Ю',
  'Я'
]

const MONTH_NAMES = {
  1: 'Январь',
  2: 'Февраль',
  3: 'Март',
  4: 'Апрель',
  5: 'Май',
  6: 'Июнь',
  7: 'Июль',
  8: 'Август',
  9: 'Сентябрь',
  10: 'Октябрь',
  11: 'Ноябрь',
  12: 'Декабрь'
}

// Days
export const APPOINTMENT_DEFAULT_TO = 3

export { AnalysisTypes, PaymentStatusTypes, alphabet, MONTH_NAMES }
